'use client';

import { useMutation } from '@apollo/client';

import {
  AddEmailToWaitlistDocument,
  AddEmailToWaitlistMutation,
  AddEmailToWaitlistMutationVariables,
  UpdateWaitlistDocument,
  UpdateWaitlistMutation,
  UpdateWaitlistMutationVariables,
} from '@/graphql';

export interface WaitlistFormData {
  email: string;
  firstName: string;
  lastName: string;
  issueDescription: string;
  organizationName: string;
  location: string;
  isIssueLeader: boolean;
}

export const useWaitlist = () => {
  const [addEmailToWaitlist, { loading: addLoading }] = useMutation<
    AddEmailToWaitlistMutation,
    AddEmailToWaitlistMutationVariables
  >(AddEmailToWaitlistDocument);

  const [updateWaitlist, { loading: updateLoading }] = useMutation<
    UpdateWaitlistMutation,
    UpdateWaitlistMutationVariables
  >(UpdateWaitlistDocument);

  const handleEmailSubmit = async (email: string) => {
    const { data } = await addEmailToWaitlist({
      variables: { email },
    });
    return data?.insertWaitlistOne?.id;
  };

  const handleFullSubmit = async (id: string, formData: WaitlistFormData) => {
    const { data } = await updateWaitlist({
      variables: {
        id,
        ...formData,
      },
    });
    return data;
  };

  return {
    handleEmailSubmit,
    handleFullSubmit,
    addLoading,
    updateLoading,
  };
};
